import { colors } from './colors';

export type Borders = typeof borders;

export const borders = {
  thinGray10: `1px solid ${colors.gray10}`,
  mediumGray10: `2px solid ${colors.gray10}`,
  thickGray10: `3px solid ${colors.gray10}`,
} as const;
